export default "__VITE_ASSET__DH3S17QD__"